/**
 * An employer name short enough for the Payment track column's second line.
 *
 * Cut at the last whole word that fits, never mid-word, so `Marriott
 * International` reads `Marriott…` rather than `Marriott I…`. A first word that
 * is already too long is kept whole. The full name goes in the tooltip.
 */

const MAX_EMPLOYER_CHARS = 10;

export function shortEmployerName(name: string, max = MAX_EMPLOYER_CHARS): string {
  const trimmed = name.trim();
  if (trimmed.length <= max) {
    return trimmed;
  }

  const words = trimmed.split(/\s+/);
  let short = words[0];
  for (const word of words.slice(1)) {
    if (`${short} ${word}`.length > max) {
      break;
    }
    short = `${short} ${word}`;
  }

  return `${short}…`;
}
